/**
 * Cart tab badge — prefixes the browser tab title with "(N)" when the cart has
 * items (e.g. "(4) Blackout Audio"), informational only.
 *
 * Count source priority:
 *   1. window.BACartCount (server-rendered on page load)
 *   2. the theme's `cart-update` pub/sub event (constants.js + pubsub.js)
 *   3. /cart.js fallback when an event payload is not a whole cart
 *
 * A shipping protection line is never counted: it is added at the checkout
 * redirect, not by the shopper (snippets/cart-count.liquid is the same rule
 * for the server-rendered counts).
 */
(function () {
  'use strict';

  var PROTECTION = ['shipping-protection', 'shipguard-shipping-protection'];

  function countOf(cart) {
    var n = cart.item_count;
    for (var i = 0; i < cart.items.length; i++) {
      if (PROTECTION.indexOf(cart.items[i].handle) !== -1) n -= cart.items[i].quantity;
    }
    return n;
  }

  function baseTitle() {
    return document.title.replace(/^\(\d+\)\s*/, '');
  }

  function applyTitle(count) {
    var base = baseTitle();
    document.title = count > 0 ? '(' + count + ') ' + base : base;
  }

  function update(count) {
    applyTitle(parseInt(count, 10) || 0);
  }

  function fetchCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        update(countOf(cart));
      })
      .catch(function () {});
  }

  function onCartUpdate(event) {
    var data = event && event.cartData;
    if (data && typeof data.item_count === 'number' && Array.isArray(data.items)) {
      update(countOf(data));
    } else {
      fetchCount();
    }
  }

  function bindEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  // Initial state
  if (typeof window.BACartCount === 'number') {
    update(window.BACartCount);
  } else {
    fetchCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }
})();
